<div class="container">
  <div class="columns">
    <div class="column col-12 callout {{ type }}">
        <ng-content></ng-content>
    </div>
  </div>
</div>
